<template>
    <div
        ref="bgImgParallax"
        class="background-image-parallax vm"
        v-bind:style="[data?.img?.url
            ? {
                'background-image': `url(${data?.img?.url})`,
                'background-position': `${mouseX}px ${mouseY}px`,
            }
            : ''
        ]"
        :class="{ enter: isMouseEnter }"
        @mouseenter="listenMouseEnter"
        @mouseleave="listenMouseLeave"
    >
        <div
            class="sub-hero__shade"
            aria-hidden="true"
        ></div>
        <Teaser
            class="sub-hero__text center"
            :title="data?.title"
            :description="data?.description"
            :buttons="data?.buttons"
        />
    </div>
</template>

<script>
// import { debounce } from '@/helpers'

import Teaser from '@/components/Text/Teaser.vue'

export default {
    components: {
        Teaser
    },
    props: {
        data: Object
    },
    data() {
        return {
            isMouseEnter: false,
            mouseX: -100,
            mouseY: -100,
            force: 30,
            el: null
        }
    },
    mounted() {
        this.el = this.$refs['bgImgParallax']

        if (true && this.el) {
            this.el.addEventListener('mousemove', this.listenMouseMove, true)
        }
    },
    methods: {
        listenMouseMove(e) {
            this.mouseX = ((e.clientX / window.innerWidth) * this.force) - 100
            this.mouseY = ((e.clientY / window.innerHeight) * this.force) - 100
        },
        listenMouseEnter() {
            this.isMouseEnter = true
            window.setTimeout(() => {
                this.listenMouseLeave()
            }, 50)
        },
        listenMouseLeave() {
            this.isMouseEnter = false
        }
    },
    unmounted() {
        if (this.el) this.el.removeEventListener('mousemove', this.listenMouseMove)
    }
}
</script>

<style
    lang="scss"
    scoped
>
.large {
    min-height: 500px;
}

.normal {
    min-height: 300px;
}

.thin {
    min-height: 260px;
}

.sub-hero__shade {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(ellipse 50% 60% at 50% 60%, rgba(218, 138, 139, 0.18), transparent 70%),
        linear-gradient(to bottom, rgba(11, 11, 14, 0.2), rgba(11, 11, 14, 0.55));
}

.sub-hero__text {
    position: relative;
    color: #fff;
    padding: 24px;
}

.sub-hero__text :deep(h1) {
    font-size: clamp(36px, 5vw, 56px);
    margin: 0;
}

.sub-hero__text :deep(h3) {
    font-weight: 500;
    opacity: 0.8;
    margin: 10px 0 0;
}

.background-image-parallax {
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;

    transition: background-position 0ms linear;
    -ms-transition: background-position 0ms linear;
    -webkit-transition: background-position 0ms linear;
}

.background-image-parallax.enter {
    transition: background-position 50ms ease-out;
    -ms-transition: background-position 50ms ease-out;
    -webkit-transition: background-position 50ms ease-out;
}

@media (min-width: $mq-medium) {
    .background-image-parallax {
        background-size: 120% 120%; // was cover
    }
}
</style>
